import React from "react";
import ReactDOM from "react-dom/client";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {CookiesProvider} from "react-cookie";
import {BrowserRouter} from "react-router-dom";
import {useTranslation} from "react-i18next";
import App from "./App";
import {AuthProvider} from "./components/auth/AuthContext";
import "./i18n";
import "./index.css";
import {AppThemeProvider} from "./theme/AppThemeProvider";

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const Root = () => {
    const {t} = useTranslation();
    document.title = t("banner.title");

    return <App />;
};

root.render(
    <React.StrictMode>
        <AppThemeProvider>
            <QueryClientProvider client={queryClient}>
                <CookiesProvider>
                    <BrowserRouter>
                        <AuthProvider>
                            <Root />
                        </AuthProvider>
                    </BrowserRouter>
                </CookiesProvider>
            </QueryClientProvider>
        </AppThemeProvider>
    </React.StrictMode>,
);
